import FlavourConfig from '../../../shared/config/flavours';
import Storage from '@storage';
import { IAppState, ISplashState } from '../../types/interfaces/states';
import { IConfig } from '../../types/interfaces/config';
import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IAppState = {
  status: {
    activeDeepLinkHandler: false,
    activeWebView: '',
    description: false,
    deviceInitialized: false,
    login: true,
    network: true,
    splash: {
      // First app load should not display ad after splash
      ads: Storage.get('first_load') === '0',
      display: true,
    },
    visibility: true,
  },
  urls: {
    // These Urls are only used in case the backend fails to respond
    account_link: FlavourConfig.defaultUrl.account,
    activate_link: FlavourConfig.defaultUrl.activate,
    register_link: FlavourConfig.defaultUrl.register,
    omnitrack_link: FlavourConfig.defaultUrl.omnitrack,
    freeOmnitrack_link: FlavourConfig.defaultUrl.freeOmnitrack,
  },
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    enableVisibility: (state) => {
      state.status.visibility = true;
    },
    disableVisibility: (state) => {
      state.status.visibility = false;
    },
    enableNetwork: (state) => {
      state.status.network = true;
    },
    disableNetwork: (state) => {
      state.status.network = false;
    },
    setWebview: (state, action: PayloadAction<string>) => {
      state.status.activeWebView = action.payload;
    },
    setDescription: (state, action: PayloadAction<boolean>) => {
      state.status.description = action.payload;
    },
    setDeviceInitialized: (state, action: PayloadAction<boolean>) => {
      state.status.deviceInitialized = action.payload;
    },
    setLogin: (state, action: PayloadAction<boolean>) => {
      state.status.login = action.payload;
    },
    setSplash: (state, action: PayloadAction<ISplashState>) => {
      state.status.splash = { ...state.status.splash, ...action.payload };
    },
    setDeeplinkHandler: (state, action: PayloadAction<boolean>) => {
      state.status.activeDeepLinkHandler = action.payload;
    },
    setUrls: (state, action: PayloadAction<IConfig[]>) => {
      action.payload?.length &&
        action.payload?.forEach((item) => {
          if (item.name && item.values && typeof item.values === 'string') {
            state.urls[item.name] = item.values;
          }
        });
    },
  },
});

const { actions, reducer: appReducer } = appSlice;
export const {
  enableNetwork,
  disableNetwork,
  setWebview,
  enableVisibility,
  disableVisibility,
  setDescription,
  setDeviceInitialized,
  setLogin,
  setSplash,
  setDeeplinkHandler,
  setUrls,
} = actions;
export const appSelector = (state: RootState) => state.app;
export default appReducer;
